import {LegacyWBIcon} from '@wandb/weave/common/components/elements/LegacyWBIcon';
import {
  AllBoundingBoxControls,
  LineStyle,
  Style,
} from '@wandb/weave/common/components/MediaCard';
import {Select} from '@wandb/weave/components/Form/Select';
import produce from 'immer';
import {set} from 'lodash';
import React, {FC} from 'react';

import {MediaBrowserPanelProps} from '../../../../../PanelMediaBrowser/Component';

type BoundingBoxStrokeTypeSelectorProps = {
  mediaKey: string;
  boxKey: string;
  boxConfig: AllBoundingBoxControls;
  updateConfig: MediaBrowserPanelProps['updateConfig'];
};

type StrokeTypeOption = {
  label: string;
  value: LineStyle;
  icon: string;
};

const STROKE_TYPE_OPTIONS: StrokeTypeOption[] = [
  {
    label: 'Solid',
    value: 'line',
    icon: 'line-solid',
  },
  {
    label: 'Dashed',
    value: 'dashed',
    icon: 'line-dash',
  },
  {
    label: 'Dotted',
    value: 'dotted',
    icon: 'line-dot',
  },
];

const DEFAULT_BOX_STYLE: Style = {lineStyle: 'line'};

export const BoundingBoxStrokeTypeSelector: FC<
  BoundingBoxStrokeTypeSelectorProps
> = ({boxConfig, updateConfig, mediaKey, boxKey}) => {
  const style = boxConfig.styles?.[mediaKey]?.[boxKey] ?? DEFAULT_BOX_STYLE;
  const updateStyle = (newStyle: Style) => {
    const newConfig = produce(boxConfig, draft => {
      // We need to set a default layout to perform updates
      set(draft, ['styles', mediaKey, boxKey], {...style, ...newStyle});
      return draft;
    });

    updateConfig({boundingBoxConfig: newConfig});
  };
  return (
    <div data-test="bounding-box-stroke-type-selector">
      <Select<StrokeTypeOption>
        isSearchable={false}
        aria-label="Stroke type"
        className="border-none outline-none"
        options={STROKE_TYPE_OPTIONS}
        onChange={option => {
          if (option) {
            updateStyle({lineStyle: option.value});
          }
        }}
        value={STROKE_TYPE_OPTIONS.find(
          option => option.value === style.lineStyle
        )}
        formatOptionLabel={option => (
          <LegacyWBIcon
            size="small"
            name={option.icon}
            aria-label={option.label}
          />
        )}
      />
    </div>
  );
};
